import { Box, Chip, Stack, Typography } from '@mui/material';

import type { LegacyLimaConnectionRowProps } from './LegacyLimaConnectionRow.types';
import { consentTileStyles } from './MsDefenderIntegration.styles';

const LegacyLimaConnectionRow = ({
  connection
}: LegacyLimaConnectionRowProps) => {
  const tenantId = connection.tenant_id ?? 'Tenant ID unavailable';

  return (
    <Box sx={consentTileStyles.connectionRow}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        sx={consentTileStyles.connectionHeader}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          sx={{ gap: 0.5, alignItems: 'center', flexGrow: 1 }}
        >
          <Typography sx={{ fontWeight: 600 }} variant="caption">
            Tenant ID:{' '}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {tenantId}
          </Typography>
          <Stack direction="row" sx={{ gap: 0.5, ml: 1 }}>
            <Chip size="small" label="Connected" color="success" />
            <Chip size="small" label="Legacy" color="default" />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default LegacyLimaConnectionRow;
